import dialog from '~/assets/icons/dialog.svg';
import exit from '~/assets/icons/exit.svg';
import star from '~/assets/icons/four_final_star_2.svg';
import { DialogueReplyIcon } from '~/shared';

export const buttonIcons = {
	[DialogueReplyIcon.NONE]: null,
	[DialogueReplyIcon.NEXT]: dialog,
	[DialogueReplyIcon.QUEST]: star,
	[DialogueReplyIcon.EXIT]: exit,
};

export const buttonColors = {
	[DialogueReplyIcon.NONE]: {
		normal: {
			bg: 'rgba(255, 255, 255, 0.05)',
			text: '#FFFFFF',
			border: 'rgba(255, 255, 255, 0.1)',
		},
		hover: {
			bg: '#FFFFFF',
			text: '#000000',
		},
	},
	[DialogueReplyIcon.NEXT]: {
		normal: {
			bg: '#2D70DA',
			text: '#FFFFFF',
			border: '',
		},
		hover: {
			bg: '#FFFFFF',
			text: '#000000',
		},
	},
	[DialogueReplyIcon.QUEST]: {
		normal: {
			bg: '#FABE2C',
			text: '#000000',
			border: '',
		},
		hover: {
			bg: '#FFFFFF',
			text: '#000000',
		},
	},
	[DialogueReplyIcon.EXIT]: {
		normal: {
			bg: 'rgba(255, 255, 255, 0.05)',
			text: '#FFFFFF',
			border: 'rgba(255, 255, 255, 0.1)',
		},
		hover: {
			bg: '#FFFFFF',
			text: '#000000',
		},
	},
};
